export default __webpack_public_path__ + "static/media/close-gray.ab127e93.svg";